import React from 'react';
import { withTranslation } from 'react-i18next';

function Error(props) {

    const { t } = props

    return (
        <div className="errorblk errorblk-activityfinder">
            <h3>{t('RecipeFinder_NoResultFound-Sorry')}</h3>
            <p>{t('RecipeFinder_NoResultFound')}</p>
        </div>
    );
}

export default withTranslation()(Error);